import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
// import PaginationOld from './PaginationOld';
import { db } from '../../firebase'


import ReactPlayer from "react-player";

function Dhaniya() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(9);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [videogallery, setVideogallery] = useState([])
    const navigate = useNavigate()

    const videogalleryCollectionRef = collection(db, "Dhaniya");
    useEffect(() => {

        const getVideogallery = async () => {
            const data = await getDocs(videogalleryCollectionRef);
            setVideogallery(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getVideogallery()
    }, [])
    return (

        <>


            <div className="album py-1">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" class="form-control" placeholder="Search" name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div className="album py-1">

                <div className="container">

                    <div className="row">
                        {videogallery.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((thehopingsunexim) => {
                            return (

                                <div className="col-md-4 mt-3" >
                                    <div className=" mb-4 ">
                                        <ReactPlayer className="mb-2" width="100%" height="100%" url={thehopingsunexim.video} />

                                        <div className="card-body">

                                            <h6 className="card-text"> <b>{thehopingsunexim.title}</b></h6>
                                            <p className="card-text">{thehopingsunexim.des}</p>
                                            {/* <h5 style={{color: "Darkblue"}}className="card-text"> ₹{website.saleprice} </h5>
                                <p style={{color: "Gray"}}className="card-text mb-2"> M.R.P.: <del> ₹{website.delete}</del> </p> */}




                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                   
                </div>
            </div>

        </>

    );
}

export default Dhaniya;